import { useCallback, useState } from 'react'

/**
 * Get a handler to pass errors to the closest react error boundary
 */
export const useAsyncError = () => {
	const [, setState] = useState<never>()
	// Use a state-update function, which is considered part of react, to pass
	// errors to the error boundary
	return useCallback(
		(error: unknown) =>
			setState(() => {
				throw error
			}),
		[],
	)
}
